import { render, staticRenderFns } from "./Modalbox.vue?vue&type=template&id=11113fe8&"
import script from "./Modalbox.vue?vue&type=script&lang=js&"
export * from "./Modalbox.vue?vue&type=script&lang=js&"
import style0 from "./Modalbox.vue?vue&type=style&index=0&id=11113fe8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports